<ng-container *ngIf="!loading; else loadingTemplate">
  <ng-container [ngSwitch]="chart.showAs" *ngIf="data?.length; else empty">
    <!-- Pie -->
    <ng-container *ngSwitchCase="chartShowModes.PieChart">
      <ngx-charts-pie-chart
        [results]="data"
        [legend]="true"
        [labels]="false"
        class="d-block chart ratio-chart-pie"
        [scheme]="chartColorScheme"
        [tooltipTemplate]="tooltipTemplate"
        [maxLabelLength]="maxLabelLength"
        legendTitle=""
      >
        <ng-template #tooltipTemplate let-model="model">
          <p class="default-paragraph pt-2 font-weight-bold">{{ model.name }}</p>
          <p class="default-paragraph p-0">
            {{ model.value }} ({{ getPercentage(model.value, model.extra.total) }}%)
          </p>
        </ng-template>
      </ngx-charts-pie-chart>
      <p class="default-paragraph text-center font-weight-bold">
        {{ dateRangeFormatters[chart.timeframe]() }}
      </p>
    </ng-container>

    <!-- Vertical bar -->
    <ng-container *ngSwitchCase="chartShowModes.VerticalBar">
      <ngx-charts-bar-vertical
        class="d-flex chart vertical-bar-data"
        [results]="data"
        [legend]="false"
        [scheme]="chartColorScheme"
        [xAxis]="true"
        [yAxis]="true"
        [showGridLines]="true"
        [showXAxisLabel]="true"
        [xAxisLabel]="dateRangeFormatters[chart.timeframe]()"
      >
        <ng-template #tooltipTemplate let-model="model">
          <p class="default-paragraph pt-2 font-weight-bold">{{ model.name }}</p>
          <p class="default-paragraph p-0">
            {{ model.value }} ({{ getPercentage(model.value, model.extra.total) }}%)
          </p>
        </ng-template>
      </ngx-charts-bar-vertical>
    </ng-container>

    <!-- Horizontal bar -->
    <ng-container *ngSwitchCase="chartShowModes.HorizontalBar">
      <ngx-charts-bar-horizontal
        [results]="data"
        [legend]="false"
        [xAxis]="true"
        [yAxis]="true"
        [showXAxisLabel]="true"
        class="d-flex chart horizontal-bar-data"
        [scheme]="chartColorScheme"
        [xAxisLabel]="dateRangeFormatters[chart.timeframe]()"
      >
        <ng-template #tooltipTemplate let-model="model">
          <p class="default-paragraph pt-2 font-weight-bold">{{ model.name }}</p>
          <p class="default-paragraph p-0">
            {{ model.value }} ({{ getPercentage(model.value, model.extra.total) }}%)
          </p>
        </ng-template>
      </ngx-charts-bar-horizontal>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loading-spinner">
    <div class="cc-icon cc-icon-spinner-3x"></div>
  </div>
</ng-template>

<ng-template #empty>
  <div class="empty">
    <img
      class="empty-placeholder"
      alt="Empty Bar chart"
      src="./assets/images/analytics/chart-bar-empty-state.svg"
    />
    <span i18n>No data to display</span>
  </div>
</ng-template>
